import React from "react";
import {Navbar, Nav} from 'react-bootstrap';

import DashboardsNav from "../base/DashboardsNav";

class OasisNavBar extends React.Component {
  constructor(props) {
		super(props);

		// this.state = {
    //   searchText: "",
		// };
    // this.onSearchTextChange = this.onSearchTextChange.bind(this);
    // this.onSearch = this.onSearch.bind(this);
	}

	async componentDidMount() {
    // console.log("expnavbar - componentDidMount - this.props.isAuthenticated: " + this.props.isAuthenticated);
    // Auth.currentUserInfo().then((userInfo) => {
    //   // const { attributes = {} } = userInfo;
    //   // console.log(userInfo);
    //   if (userInfo) {
    //     this.setState({username: userInfo.username});
    //   }
    // });
	}

  showSettings (event) {
    event.preventDefault();
  }

  render() {
    // console.log("ExpNavBar.js - in render");
    // console.log("ExpNavBar.js - render - this.props.isAuthenticated - " + this.props.isAuthenticated);
    // let userDetails = sessionStorage.getItem('userDetails');
    // console.log("userDetails are:");
    // console.log(userDetails);
    // let username = userDetails.username;
    // if (userDetails) {
    //   username = userDetails.username;
    // }
    // console.log("username is: " + username);

    return (
      <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark" sticky="top">
        <Navbar.Brand href="/"><img src="/images/logo/oasis-logo.png" width="32"
          height="32" className="d-inline-block align-top" alt="Oasis"
          />&nbsp;&nbsp;Oasis Analytics</Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            <Nav.Link eventKey={1.10} href="/">Validators</Nav.Link>
            {/* <Nav.Link eventKey={1.11} href="/account">My Account</Nav.Link> */}
            <Nav.Link eventKey={1.12} href="/history">Network</Nav.Link>
            <Nav.Link eventKey={1.20} href="https://d14n.smartstake.io/?ref=oasis">Decentralization</Nav.Link>
            <DashboardsNav />
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}
/*
<NavDropdown title="Tools" id="basic-nav-dropdown">
  <NavDropdown.Item href="/richlist">Richlist</NavDropdown.Item>
  <NavDropdown.Item href="/calc">Staking Calculator</NavDropdown.Item>
</NavDropdown>
<NavDropdown.Divider />
<Form inline onSubmit={this.onSearch}>
  <FormControl type="text" placeholder="Search" className="mr-sm-2"
    placeholder="Enter Address, Public Key, or Name"
    onChange={this.onSearchTextChange} />
  <Button variant="outline-success">Search</Button>
</Form>

onSearchTextChange = (value) => {
  let searchText = value.target.value;

  if (searchText != null) {
    searchText = searchText.toLowerCase();
  }
  // console.log("onAliasChange: value is: ", alias);
  this.setState("searchText", searchText);
}

onSearch = (e) => {
  e.preventDefault();
  // console.log("FilterRewards - in filterData: ", this.props.filterState);
  if (this.state.searchText == undefined || this.state.searchText.length < 2) {
    alert("Please enter an address, public key, or validator name to search.");
    return false;
  }
  alert("searched for: ", this.state.searchText);
}
*/

export default OasisNavBar;



// WEBPACK FOOTER //
// ./src/base/OasisNavBar.js